"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _default = (0, _styledComponents.default)(_UISelectableBox.default).withConfig({
  displayName: "CalculatorSelectableBox",
  componentId: "sc-1s7knxi-0"
})(["&&&{width:100%;border-radius:0;&:hover{z-index:8;}", ";", ";}.plan-selector-button-text{font-size:12px;}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && (0, _styledComponents.css)(["border-color:", " !important;font-weight:400;"], _colors.GREAT_WHITE);
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected && (0, _styledComponents.css)(["z-index:7;font-weight:600;"]);
});

exports.default = _default;
module.exports = exports.default;